// Resolve a player → its org UserProfile. Primary join is `player.user`, but
// players registered before the person had a User account have no `user` set;
// in that case fall back to matching by normalized email (the `list` endpoint
// stamps each profile's `userEmail`). Both sides are trimmed + lowercased.
import _ from 'lodash';
import helpers from './helpers';

export const normEmail = (e: any): string => String(e || '').trim().toLowerCase();

export interface UserProfileMaps {
  byUser: Record<string, any>;
  byEmail: Record<string, any>;
}

export function buildUserProfileMaps(userProfiles: any[] = []): UserProfileMaps {
  const byUser: Record<string, any> = {};
  const byEmail: Record<string, any> = {};
  for (const up of userProfiles) {
    const uid = helpers.getObjId(up.user);
    if (uid) byUser[uid] = up;
    const em = normEmail(up.userEmail);
    if (em && !byEmail[em]) byEmail[em] = up;
  }
  return { byUser, byEmail };
}

export function resolveUserProfile(maps: UserProfileMaps | undefined, player: any): any {
  const byUser = maps?.byUser?.[helpers.getObjId(player?.user) as string];
  if (byUser) return byUser;
  return maps?.byEmail?.[normEmail(_.get(player, 'info.email') || player?.email)];
}
